import { Button, Card, Typography } from "antd"
import { Visit } from "../scheduleApi"
import ManageVisitNotes from "./Modals/ManageVisitNotes"
import { useState } from "react"
import VisitPhotos from "../VisitPhotos"

const { Text } = Typography

type Props = {
  visit: Visit | undefined
}

const JobDrawerVisitNotes = ({ visit }: Props) => {
  const [isManageVisitNotesOpen, setIsManageVisitNotesOpen] = useState(false)

  return <>
    <div style={{ marginBottom: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <Text style={{ fontSize: '14px' }}>
            Notes & Photos
          </Text>
          <span>
            <Button
              onClick={() => setIsManageVisitNotesOpen(true)}
              disabled={!visit}>
              {visit && (visit.internalNotes !== null && visit.internalNotes !== '') ? 'Edit Notes' : 'Add'}
            </Button>
          </span>
        </div>
      </div>

      {visit && visit.internalNotes && <Card>
        <div>
          <p>{visit.internalNotes}</p>
        </div>
      </Card>}

      {!visit &&
        <div style={{
          border: '2px dashed #d9d9d9',
          borderRadius: '6px',
          padding: '40px 20px',
          textAlign: 'center',
          backgroundColor: 'transparent'
        }}>
          <Text style={{ color: '#8c8c8c', fontSize: '14px' }}>No associated visit</Text>
        </div>
      }

      {visit && (visit.internalNotes === null || visit.internalNotes === '') &&
        <div style={{
          border: '2px dashed #d9d9d9',
          borderRadius: '6px',
          padding: '40px 20px',
          textAlign: 'center',
          backgroundColor: 'transparent'
        }}>
          <Text style={{ color: '#8c8c8c', fontSize: '14px' }}>No visit notes</Text>
        </div>
      }

      {visit && <VisitPhotos visitId={visit.id} />}
    </div>
    <ManageVisitNotes open={isManageVisitNotesOpen} onClose={() => setIsManageVisitNotesOpen(false)} visit={visit} />
  </>
}

export default JobDrawerVisitNotes